import React from 'react';

const ArrowSeparator = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="75" height="25" viewBox="0 0 75 25" fill="none">
    <path d="M0 13L20.1522 24.2793L19.8443 1.18738L0 13ZM75 12L54.8478 0.720663L55.1557 23.8126L75 12ZM18.0251 14.7598L57.0283 14.2398L56.9749 10.2402L17.9717 10.7602L18.0251 14.7598Z" fill="#84BD00"/>
  </svg>
);

function AboutUs() {
  return (
    <div className="page splash aboutUsPage">
      <div className="background" />
      <div className="green-text">
        Agilysys offers the broadest integrated hospitality software portfolio with the deepest functionality in the market, empowering the friendly and generous reception of guests and members by providing accommodation, food, drink, entertainment or other services to deliver a truly exceptional experience across their entire journey.
      </div>
      <div className="text-wrapper">
        <div className="head">
          Agilysys Hospitality Experience Cloud
        </div>
        <div className="body">
          The comprehensive <strong>High Return Hospitality</strong> solution{"\n"}
          <span>where personal meets profitable</span>
        </div>
        <div className="footer">
          Higher Guest Returns
          <ArrowSeparator />
          Higher Economic Returns
        </div>
      </div>
    </div>
  );
}

export default AboutUs;


